const FORMAT = 'YYYY-MM';

angular.module('zc')
  .component('zcSummarySiteReport', {
    templateUrl: '/templates/projects.site_reports/summary.html',
    bindings: { project: '<' },
    controller: zcSummarySiteReportController,
  });

zcSummarySiteReportController.$inject = ['$filter', '$state', '$stateParams', 'Page', 'Devise', 'Apollo'];
function zcSummarySiteReportController($filter, $state, $stateParams, Page, Devise, Apollo) {
  const vm = this;

  const thisMonthStartAt = $filter('changeDatetimeFrom')('localToRegion', moment($stateParams.month, FORMAT).toDate());
  const thisMonthEndAt = moment(thisMonthStartAt).add(1, 'month').toDate();
  const lastMonthStartAt = moment(thisMonthStartAt).subtract(1, 'month').toDate();
  const lastYearStartAt = moment(thisMonthStartAt).subtract(1, 'year').toDate();

  if(!Devise.isMaster() && !vm.project.shows_site_report) {
    $state.go('admin.projects.campaigns.list', { projectId: vm.project.id });
    return;
  }

  Page.setBodyClass('');
  Page.setTitle('サマリーレポート');

  vm.$onInit = () => {
    getProject()
      .then(project => {
        vm.project = _.extend({}, vm.project, project);
      });
  };

  function getProject() {
    return Apollo.query(gql(`{
      project(apikey: "${vm.project.apikey}") {
        title
        budget
        max_invoice
        pc_control_percent
        sp_control_percent
        product_line
        campaigns(start_at: {lt: "${thisMonthEndAt.toISOString()}"}, end_at: {gte: "${thisMonthStartAt.toISOString()}"}) {
          id
          name
          custom_css
          campaign_type
          template_type
          campaign_device
          start_at
          end_at
          campaign_control_percent
          element {
            message
          }
          segment {
            id
            name
            description
          }
        }
        invoices(start_at: {gte: "${lastYearStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          invoice_price_tax_excluded
          start_at
        }
        zcs_invoices(start_at: {gte: "${lastYearStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          invoice_price_tax_excluded
          month
        }
        monthlyStats: monthlySiteReportStats(start_at: {gte: "${lastYearStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          all_access {
            session_count
            conversion_price
          }
          all_campaign {
            session_count
            conversion_price
          }
          campaigns {
            campaign_id
            session_count
            conversion_price
            conversion_count
            conversion_rate
            average_conversion_price
            cart_button_click_count
            cart_button_click_rate
            contribution_price
            conversion_up_rate
            conversion_price_up_rate
          }
          devices {
            device
            session_count
            conversion_price
            contribution_price
          }
          conversion_segments {
            conversion_segments
            session_count
            conversion_price
            contribution_price
          }
          utm_mediums {
            utm_medium
            session_count
            conversion_price
            contribution_price
          }
          session_cover_rate
          conversion_cover_rate
          contribution_price
          contribution_rate
          start_at
        }
        dailyStats: dailySiteReportStats(start_at: {gte: "${thisMonthStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          all_access {
            session_count
            conversion_price
          }
          all_campaign {
            session_count
            conversion_price
          }
          session_cover_rate
          conversion_cover_rate
          start_at
        }
        cumulativeDailyStats: cumulativeDailySiteReportStats(start_at: {gte: "${thisMonthStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          all_access {
            conversion_price
          }
          all_campaign {
            conversion_price
          }
          contribution_price
          contribution_rate
          start_at
        }
      }
    }`))
      .then(res => res.project)
      .then(reduceProject);
  }

  function reduceProject(project) {
    project = _.cloneDeep(project);
    project.thisMonthStat = _.find(project.monthlyStats, { start_at: thisMonthStartAt.toISOString() });
    project.lastMonthStat = _.find(project.monthlyStats, { start_at: lastMonthStartAt.toISOString() });
    project.lastYearStat = _.find(project.monthlyStats, { start_at: lastYearStartAt.toISOString() });
    if(project.product_line === 'zenclerk_s') {
      project.thisMonthInvoice = _.find(project.zcs_invoices, { month: moment(thisMonthStartAt).format(FORMAT) });
      project.lastMonthInvoice = _.find(project.zcs_invoices, { month: moment(lastMonthStartAt).format(FORMAT) });
      project.lastYearInvoice = _.find(project.zcs_invoices, { month: moment(lastYearStartAt).format(FORMAT) });
    } else {
      project.thisMonthInvoice = _.find(project.invoices, { start_at: thisMonthStartAt.toISOString() });
      project.lastMonthInvoice = _.find(project.invoices, { start_at: lastMonthStartAt.toISOString() });
      project.lastYearInvoice = _.find(project.invoices, { start_at: lastYearStartAt.toISOString() });
    }
    project.campaigns = reduceCampaigns(project);
    project.is_abtest = _.every(project.campaigns, campaign => campaign.control_percent >= 1);
    project.is_loaded = true;
    return project;
  }

  function reduceCampaigns(project) {
    if(!project.thisMonthStat) return project.campaigns;
    return project.campaigns.reduce((memo, campaign) => {
      // NOTE: GraphQL ID is treated only as string, so the type mismatch happens between Mongo and SQL
      const stat = _.find(project.thisMonthStat.campaigns, { campaign_id: parseInt(campaign.id) });
      if(!stat || !stat.session_count) return memo;
      memo.push(_.extend({ control_percent: getControlPercent(project, campaign) }, campaign, stat));
      return memo;
    }, []);
  }

  function getControlPercent(project, campaign) {
    if(campaign.campaign_control_percent !== null) return campaign.campaign_control_percent;
    return campaign.campaign_device === 'pc'
      ? project.pc_control_percent
      : project.sp_control_percent; // sp, iphone, tablet
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.site_reports/summary.controller.js